import moment, { Moment } from "moment";

export type HistoryDateRangePreset = "2weeks" | "1month" | "3months" | "custom";
export type HistoryDateRangeButtonPreset = Exclude<HistoryDateRangePreset, "custom">;

export const HISTORY_DATE_RANGE_OPTIONS: { value: HistoryDateRangeButtonPreset; label: string }[] = [
  { value: "2weeks", label: "Last 2 weeks" },
  { value: "1month", label: "Last month" },
  { value: "3months", label: "Last 3 months" },
];

export const DEFAULT_HISTORY_DATE_RANGE: HistoryDateRangeButtonPreset = "2weeks";

export function getHistoryDateRange(preset: HistoryDateRangeButtonPreset): {
  fromDate: Moment;
  toDate: Moment;
} {
  const toDate = moment();
  switch (preset) {
    case "1month":
      return { fromDate: moment().subtract(1, "month"), toDate };
    case "3months":
      return { fromDate: moment().subtract(3, "months"), toDate };
    case "2weeks":
    default:
      return { fromDate: moment().subtract(2, "weeks"), toDate };
  }
}
